<unity-page-container class="user-dashboard-view" contentHeader="Dashboard" [isLoading]="false">
  <ng-container notifications />

  <ng-container actions>
    <unity-action-shared [action]="createAgreementAction" />
    <unity-action-shared [action]="viewAgreementsAction" />
    <unity-action-shared [action]="createFormSchemaAction" />
    <unity-action-shared [action]="manageFormSchemasAction" />
    <unity-action-shared [action]="createProgramAction" />
    <unity-action-shared [action]="manageProgramsAction" />
    <unity-action-shared [action]="createVendorAction" />
    <unity-action-shared [action]="manageVendorsAction" />
    <unity-action-shared [action]="createCommunityAction" />
    <unity-action-shared [action]="manageCommunitiesAction" />
    <unity-action-shared [action]="createBusinessPartnerAction" />
    <unity-action-shared [action]="manageBusinessPartnersAction" />
    <unity-action-shared [action]="createInternalUserAction" />
    <unity-action-shared [action]="createUserAction" />
    <unity-action-shared [action]="manageUsersAction" />
    <unity-action-shared [action]="listReportsAction" />
    @if ($isImpersonating()) {
      <unity-action-shared [action]="exitImpersonationAction" />
    }
    <unity-action-shared [action]="logoutAction" />
  </ng-container>
</unity-page-container>
